import { AnaColumn } from "../forms-template.service";

export const CrmStatisticheProcedure: AnaColumn[] = [

  {
    itemType: 'group',
    caption: '',
    captionClass: 'd-none',
    class: '',
    colCount: 5,
    colGroup: 10,
    data: [
      /* {
        type: 'campo',
        dataField: 'CodContatto',
        colVisible: false,
        dataType: 'string',
        caption: 'Contatto',
        allowFiltering: false,
        disableOnUpdate: true,
        disabled: false,
        colAlignment: 'left',
        showClearButton: true,
        nCol: 3,
        editorType: 'dxSelectBox',
        class: 'crm_contatti_editor me-2',
        dynamic: {
          valueExpr: 'Cod',
          queryString: '',
          displayExpr: 'RagSoc',
          dataSource: 'contatti',
          service: '',
          autocomplete: false,
          caption: 'Lista Contatti',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Contatti',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc',
                dataType: '',
                caption: 'Ragione Sociale',
                allowEditing: true,
              },
            ],
          },
        },
      }, */
      {
        type: 'campo',
        dataField: 'CodAgente',
        colVisible: false,
        dataType: 'string',
        caption: 'Agente',
        allowFiltering: false,
        disableOnUpdate: true,
        disabled: false,
        colAlignment: 'left',
        showClearButton: true,
        placeHolder: 'Tutti',
        nCol: 3,
        class: 'crm_contatti_editor me-2',
        editorType: 'dxSelectBox',
        dynamic: {
          valueExpr: 'Cod',
          queryString: '',
          displayExpr: 'RagSoc1',
          dataSource: 'agenti',
          service: '',
          autocomplete: false,
          caption: 'Lista Agenti',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Agenti',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc1',
                dataType: '',
                caption: 'Ragione Sociale',
                allowEditing: true,
              },
              {
                dataField: 'Resp',
                dataType: '',
                caption: 'Responsabili',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'CodProcedura',
        colVisible: false,
        dataType: 'string',
        class: 'crm_contatti_editor me-2',
        caption: 'Procedura Principale',
        allowFiltering: false,
        disableOnUpdate: true,
        disabled: false,
        colAlignment: 'left',
        showClearButton: true,
        placeHolder: 'Tutte',
        nCol: 3,
        editorType: 'dxSelectBox',
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?isModulo=0',
          displayExpr: 'Des',
          dataSource: 'procedure',
          service: '',
          autocomplete: false,
          caption: 'Lista Procedure',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Procedure',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'Sigla',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
              },
              {
                dataField: 'Des',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'escludiModuli',
        caption: 'Escludi Opzionali',
        dataType: 'boolean',
        class: 'my-3 crm_contatti_editor me-2',
        editorType: 'dxCheckBox',
        defaultValue: true,
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        colVisible: true,
        class: 'crm_contatti_editor me-2',
        dataType: 'string',
        showClearButton: true,
        caption: 'Procedura Opzionale',
        disableOnUpdate: true,
        disabled: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        allowFiltering: false,
        nCol: 3,
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?isModulo=1',
          displayExpr: 'Des',
          filter: '',
          dataSource: 'procedure',
          service: '',
          autocomplete: false,
          caption: 'Lista Moduli',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Moduli',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'Sigla',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
              },
              {
                dataField: 'Des',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'anniConfronto',
        editorType: "dxSelectBox",
        dataType: 'string',
        class: 'crm_contatti_editor',
        disableOnUpdate: true,
        caption: 'Anni di riferimento',
        nCol: 1,
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'name',
          selectFirstElement: true,
          isDefaultOption: false,
          static: true,
          items: [
            {
              id: 0, name: `Solo ${new Date().getFullYear()}`,
            },
            {
              id: 1, name: `Dal ${new Date().getFullYear()} al ${new Date().getFullYear() - 1}`,
            },
            {
              id: 2, name: `Dal ${new Date().getFullYear()} al ${new Date().getFullYear() - 2}`,
            },
            {
              id: 3, name: `Dal ${new Date().getFullYear()} al ${new Date().getFullYear() - 3}`,
            },
            {
              id: 4, name: `Dal ${new Date().getFullYear()} al ${new Date().getFullYear() - 4}`,
            }
          ]
        }
      },
    ]
  },
]